import { useMediaQuery } from '@material-ui/core';
import { MuiThemeProvider, useTheme } from '@material-ui/core/styles';
import { Redirect, useHistory, useParams } from 'react-router-dom';
import { useCurrentUser } from '../../Session';
import { UserType } from '../../api';
import BasicLayout from '../../layouts/BasicLayout';
import basicTheme from '../../layouts/BasicLayout/basicTheme';
import PurchaseTransactionDetail from '../../pages/PurchaseTransactions/PurchaseTransactionDetail';

interface RouteParams {
    transactionId: string;
}

const PurchaseTransactionDetailRoute = () => {
    const currentUser = useCurrentUser();
    const history = useHistory();
    const theme = useTheme();
    const params = useParams<RouteParams>();

    const isSmall = useMediaQuery(theme.breakpoints.down('sm'));

    if (
        ![UserType.Admin, UserType.Root, UserType.SaleConsultant, UserType.ValuationTeam, UserType.Approver].includes(
            currentUser.type
        )
    ) {
        return <Redirect to="/403" />;
    }

    if (isSmall) {
        return (
            <MuiThemeProvider theme={basicTheme}>
                <PurchaseTransactionDetail transactionId={params.transactionId} />
            </MuiThemeProvider>
        );
    }

    return (
        <BasicLayout onBack={history.goBack}>
            <PurchaseTransactionDetail transactionId={params.transactionId} />
        </BasicLayout>
    );
};

export default PurchaseTransactionDetailRoute;
